
import { Modal } from "react-bootstrap";

export const getDocumentTitle = (doc) => {
  if (doc?.documentMetadata?.name) return doc.documentMetadata.name;
  if (doc?.fileMetadata?.fileName) return doc.fileMetadata.fileName;
  return "Untitled document";
};

const PreviewDocument = ({ document, onClose }) => {
  return (
    <Modal show centered size="lg" onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>{getDocumentTitle(document)}</Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ height: "75vh" }}>
        <iframe
          src={document.fileMetadata?.url}
          title="document-preview"
          style={{ width: "100%", height: "100%", border: "none" }}
        />
      </Modal.Body>
    </Modal>
  );
};

export default PreviewDocument;
